import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.all_sales').controller('AccountingCtrl', AccountingCtrl)

/** @ngInject */
function AccountingCtrl($scope, AllSalesService) {

  var vm = this
  vm.parent = $scope.$parent.vm

  // Date Picker state
  vm.date1 = new Date(new Date().getFullYear(), 0, 1)
  vm.date2 = ''

  vm.openCalendarStart = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpenStart = true
  }

  vm.openCalendarEnd = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpenEnd = true
  }

  // Filter Models
  vm.filters = {
    channels: [],
  }

  vm.summary = {
    qtyAvailable: 0,
    qtySold: 0,
    freeQtyAvailable: 0,
    freeQtyClaimed: 0,
    totalRevenue: 0,
  }

  vm.channels = []
  vm.loading = false
  vm.exportLoading = false

  vm.toggleChannel = function (channel) {
    channel.expanded = !channel.expanded
  }

  vm.resetFilters = function () {
    vm.date1 = new Date(new Date().getFullYear(), 0, 1)
    vm.date2 = ''
    vm.filters.channels = []
    vm.reload()
  }

  vm.load = function () {
    var startDate = vm.date1 ? Math.floor(moment(vm.date1).valueOf() / 1000) : null
    var endDate = vm.date2 ? Math.floor(moment(vm.date2).valueOf() / 1000) : null

    if (startDate && endDate && startDate > endDate) {
      swal('Invalid Date Range', 'End Date cannot be before Start Date.', 'warning')
      return
    }

    vm.loading = true
    AllSalesService.getAccounting(startDate, endDate, vm.filters.channels)
      .then(function (res) {
        vm.loading = false
        if (res && res.result) {
          // Map summary
          vm.summary = {
            qtyAvailable: res.result.total_avail || 0,
            qtySold: res.result.total_sold || 0,
            freeQtyAvailable: res.result.free_avail || 0,
            freeQtyClaimed: res.result.free_claimed || 0,
            totalRevenue: res.result.total_rev || 0,
          }

          // Map channels
          if (res.result.c) {
            vm.channels = res.result.c.map(function (ch, index) {
              return {
                id: ch['id-c'],
                name: ch.t,
                totalRevenue: ch.rev || 0,
                packsSold: ch.sold || 0,
                packsAvailable: ch.avail || 0,
                freePacksClaimed: ch.f_claim || 0,
                freePacksAvailable: ch.f_avail || 0,
                // expanded: index === 0,
                expanded: false,
                bundles: ch.b
                  ? ch.b.map(function (b) {
                      var statusMapping = {
                        1: 'PUBLISHED',
                        2: 'SOLD OUT',
                        7: 'UNAVAILABLE',
                        10: 'AWAITING COLLECTIBLE COUNT',
                      }
                      return {
                        id: b['id-b'],
                        name: b.t,
                        price: Number(b.price) <= 0 ? 'FREE' : b.price,
                        status: statusMapping[b.st] || 'UNKNOWN',
                        qtyAvailable: b.tc ? b.avail || 0 : 'UNLIMITED',
                        qtySold: b.sold || 0,
                        revenue: b.rev || 0,
                        'img-t': b['img-t'],
                      }
                    })
                  : [],
              }
            })
          } else {
            vm.channels = []
          }
        }
      })
      .catch(function (err) {
        vm.loading = false
        console.error('Failed to load accounting data', err)
        swal('Error', 'Failed to fetch accounting data.', 'error')
      })
  }

  vm.reload = function () {
    vm.load()
  }

  vm.export = function () {
    if (vm.exportLoading) return

    var startDate = vm.date1 ? Math.floor(moment(vm.date1).valueOf() / 1000) : null
    var endDate = vm.date2 ? Math.floor(moment(vm.date2).valueOf() / 1000) : null

    if (startDate && endDate && startDate > endDate) {
      swal('Invalid Date Range', 'End Date cannot be before Start Date.', 'warning')
      return
    }

    vm.exportLoading = true
    AllSalesService.exportAccounting(startDate, endDate, vm.filters.channels)
      .then(function (response) {
        if (response && response.data) {
          const headers = response.headers()

          let disposition =
            response.headers('content-disposition') || response.headers('Content-Disposition')
          if (!disposition && headers) {
            disposition = headers['content-disposition'] || headers['Content-Disposition']
          }

          // Fallback filename if header is missing
          let dateStr = moment().format('YYYY-MM-DD')
          let filename = 'accounting_' + dateStr + '.csv'

          if (disposition && disposition.indexOf('attachment') !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }

          // Create blob from arraybuffer
          const blob = new Blob([response.data], {
            type: response.headers('content-type') || 'text/csv;charset=utf-8;',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()

          setTimeout(function () {
            window.URL.revokeObjectURL(url)
            document.body.removeChild(link)
          }, 100)
        }
      })
      .catch(function (err) {
        console.error('Export failed', err)
        swal('Export Error', 'Failed to export CSV. Please try again.', 'error')
      })
      .finally(function () {
        vm.exportLoading = false
        if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
          $scope.$apply()
        }
      })
  }

  vm.load()
}
